import React, { useEffect } from 'react'
import useSearch from '../../../context/search/useSearch'
import SearchProductCard from './Components/SearchProductCard'
import SearchSubmit from './SearchSubmit'

interface ISearchResultsProductsComponent {
  dataSet: DOMStringMap
}

const SearchResultsProducts: React.FC<ISearchResultsProductsComponent> = ({dataSet}): JSX.Element => {

  const {langTitle, langTitleRecent} = dataSet

  const {
    quickSearchResultsProducts,
    quickSearchTerm,
    activeTab
  } = useSearch()


  const productsTitle = quickSearchTerm ? langTitle : langTitleRecent

  // Only render if products tab is active
  if (activeTab !== 'products') {
    return null;
  }

  useEffect(() => {
    if (quickSearchTerm && quickSearchResultsProducts) {
      document.querySelector('body').classList.add('search-loaded');
    } else {
      document.querySelector('body').classList.remove('search-loaded');
    }
  }, [quickSearchResultsProducts]);

  return (
    quickSearchResultsProducts && quickSearchResultsProducts.length ? (
      <div className={`search__results search__results--grid search__results--products ${quickSearchResultsProducts && quickSearchResultsProducts.length && 'search__results--loaded'}`}>
        {(quickSearchResultsProducts && quickSearchResultsProducts.length) && <>

          {productsTitle && <h5 className={'search__results-title search__results-title--products subheading'}>
            {productsTitle}
            <SearchSubmit dataSet={{submitText: 'View all'}} />
          </h5>}

          <div className={'search__results-grid search__results-grid--products'}>
            {quickSearchResultsProducts.map((product, index) => {
              return (
                <SearchProductCard key={index} product={product} simple={true} modifier="search-results" />
              )
            })}
          </div>
        </>}
      </div>
    ) : null
  )
}

export default SearchResultsProducts